import React from "react";
import SellerTable from "../Components/dashboard/SellerTable";

const Users = () => {
  return <SellerTable />;
};

export default Users;
